module.exports = __webpack_public_path__ + "src/asset/svg/title/artist1.svg?5dbdff29ff3f39ca2e6eb1cee39243d6";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/title/artist1.svg
// module id = 17
// module chunks = 0